document.addEventListener("DOMContentLoaded", function () {
  try {
    const lang = document.documentElement.lang.startsWith('ar') ? 'ar' : 'en';
    const isArabic = lang === 'ar';

    const container = document.getElementById('delivery-estimate-container');
    const inputContainer = document.getElementById('input-container');
    const estimateBox = document.getElementById('deliveryEstimate');
    const estimateText = document.getElementById('estimateText');
    const labelText = document.getElementById('label-text');
    const deliveryTitle = document.querySelector(".delivery-title");
    const flagSpan = document.getElementById('selected-flag');

    container.setAttribute('dir', isArabic ? 'rtl' : 'ltr');
    labelText.textContent = labelText.getAttribute(`data-${lang}`);
    deliveryTitle.textContent = deliveryTitle.getAttribute(`data-${lang}`);

    const daysAr = ["الأحد", "الإثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"];
    const daysEn = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const monthsAr = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];
    const monthsEn = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

    const flagCodes = {
      "الإمارات": "ae", "السعودية": "sa", "الكويت": "kw",
      "قطر": "qa", "البحرين": "bh"
    };

    const gulfCountries = {
      "الإمارات": { from: 5, to: 7 }, "السعودية": { from: 5, to: 7 },
      "الكويت": { from: 5, to: 7 }, "قطر": { from: 5, to: 7 }, "البحرين": { from: 5, to: 7 }
    };

    const omanAreas = window.omanAreasData || [ // محافظة مسقط
 {
    "zone_english": "Al Khoudh",
    "zone_arabic": "الخوض",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية السيب",
    "province_english": "Seeb Governorate"
  },
  {
    "zone_english": "Al Hail",
    "zone_arabic": "الحيل",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية السيب",
    "province_english": "Seeb Governorate"
  },
  {
    "zone_english": "Al Maabela",
    "zone_arabic": "المعبيلة",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية السيب",
    "province_english": "Seeb Governorate"
  },
  {
    "zone_english": "Al Rusayl",
    "zone_arabic": "الرسيل",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية السيب",
    "province_english": "Seeb Governorate"
  },
  {
    "zone_english": "Al Mazare'",
    "zone_arabic": "المزارع",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية السيب",
    "province_english": "Seeb Governorate"
  },
  {
    "zone_english": "Al Mawaleh",
    "zone_arabic": "الموالح",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية السيب",
    "province_english": "Seeb Governorate"
  },
  {
    "zone_english": "Al Nahdha",
    "zone_arabic": "النهضة",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية السيب",
    "province_english": "Seeb Governorate"
  },
  {
    "zone_english": "Al Sharadi",
    "zone_arabic": "الشرادي",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية السيب",
    "province_english": "Seeb Governorate"
  },
  {
    "zone_english": "Al Batinah",
    "zone_arabic": "البطينة",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية السيب",
    "province_english": "Seeb Governorate"
  },
  {
    "zone_english": "Seeb Industrial",
    "zone_arabic": "السيب الصناعية",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية السيب",
    "province_english": "Seeb Governorate"
  },
  {
    "zone_english": "Al Ghubrah",
    "zone_arabic": "الغبرة",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بوشر",
    "province_english": "Bawshar Governorate"
  },
  {
    "zone_english": "Al Khuwair",
    "zone_arabic": "الخوير",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بوشر",
    "province_english": "Bawshar Governorate"
  },
  {
    "zone_english": "Al Azaiba",
    "zone_arabic": "العذيبة",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بوشر",
    "province_english": "Bawshar Governorate"
  },
  {
    "zone_english": "Al Qurum",
    "zone_arabic": "القرم",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بوشر",
    "province_english": "Bawshar Governorate"
  },
  {
    "zone_english": "Ghala",
    "zone_arabic": "غلا",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بوشر",
    "province_english": "Bawshar Governorate"
  },
  {
    "zone_english": "Al Ansab",
    "zone_arabic": "الانصب",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بوشر",
    "province_english": "Bawshar Governorate"
  },
  {
    "zone_english": "Al Rusayl",
    "zone_arabic": "الرسيل",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بوشر",
    "province_english": "Bawshar Governorate"
  },
  {
    "zone_english": "Wattayah",
    "zone_arabic": "الوطية",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية مطرح",
    "province_english": "Mutrah Governorate"
  },
  {
    "zone_english": "Al Qurum",
    "zone_arabic": "القرم",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية مطرح",
    "province_english": "Mutrah Governorate"
  },
  {
    "zone_english": "Ruwi",
    "zone_arabic": "روَي",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية مطرح",
    "province_english": "Mutrah Governorate"
  },
  {
    "zone_english": "Darsait",
    "zone_arabic": "دارسيت",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية مطرح",
    "province_english": "Mutrah Governorate"
  },
  {
    "zone_english": "Wadi Kabir",
    "zone_arabic": "الوادي الكبير",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية مطرح",
    "province_english": "Mutrah Governorate"
  },
  {
    "zone_english": "Al Fath",
    "zone_arabic": "الفتح",
    "delivery_days": "2",
    "delivery_mode": "standard",
    "province_arabic": "ولاية العامرات",
    "province_english": "Al Amarat Governorate"
  },
  {
    "zone_english": "Al Murtafa'ah",
    "zone_arabic": "المرتفعة",
    "delivery_days": "2",
    "delivery_mode": "standard",
    "province_arabic": "ولاية العامرات",
    "province_english": "Al Amarat Governorate"
  },
  {
    "zone_english": "Al Hajar",
    "zone_arabic": "الحاجر",
    "delivery_days": "2",
    "delivery_mode": "standard",
    "province_arabic": "ولاية العامرات",
    "province_english": "Al Amarat Governorate"
  },
  {
    "zone_english": "Madinat Al Nahda",
    "zone_arabic": "مدينة النهضة",
    "delivery_days": "2",
    "delivery_mode": "standard",
    "province_arabic": "ولاية العامرات",
    "province_english": "Al Amarat Governorate"
  },
  {
    "zone_english": "Central Al Amerat",
    "zone_arabic": "العامرات المركزية",
    "delivery_days": "2",
    "delivery_mode": "standard",
    "province_arabic": "ولاية العامرات",
    "province_english": "Al Amarat Governorate"
  },
  {
    "zone_english": "Dabab",
    "zone_arabic": "ضباب",
    "delivery_days": "2",
    "delivery_mode": "standard",
    "province_arabic": "ولاية قريات",
    "province_english": "Qurayyat Governorate"
  },
  {
    "zone_english": "Fins",
    "zone_arabic": "فنس",
    "delivery_days": "2",
    "delivery_mode": "standard",
    "province_arabic": "ولاية قريات",
    "province_english": "Qurayyat Governorate"
  },
  {
    "zone_english": "Ad Duwiyah",
    "zone_arabic": "الدوية",
    "delivery_days": "2",
    "delivery_mode": "standard",
    "province_arabic": "ولاية قريات",
    "province_english": "Qurayyat Governorate"
  },
  {
    "zone_english": "Al Mazare'",
    "zone_arabic": "المزارع",
    "delivery_days": "2",
    "delivery_mode": "standard",
    "province_arabic": "ولاية قريات",
    "province_english": "Qurayyat Governorate"
  },
  {
    "zone_english": "Al Rumais",
    "zone_arabic": "الرميس",
    "delivery_days": "2",
    "delivery_mode": "standard",
    "province_arabic": "ولاية قريات",
    "province_english": "Qurayyat Governorate"
  },
  {
    "zone_english": "Al Hajar",
    "zone_arabic": "الحاجر",
    "delivery_days": "2",
    "delivery_mode": "standard",
    "province_arabic": "ولاية قريات",
    "province_english": "Qurayyat Governorate"
  },
  {
    "zone_english": "Al Bustan",
    "zone_arabic": "البستان",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية مسقط",
    "province_english": "Muscat Governorate"
  },
  {
    "zone_english": "Port",
    "zone_arabic": "الميناء",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية مسقط",
    "province_english": "Muscat Governorate"
  },
  {
    "zone_english": "Greater Mutrah",
    "zone_arabic": "مطرح الكبرى",
    "delivery_days": "1",
    "delivery_mode": "standard",
    "province_arabic": "ولاية مسقط",
    "province_english": "Muscat Governorate"
  },
  // محافظة شمال الباطنة
  {
    "zone_english": "Al Hujrah",
    "zone_arabic": "الحجرة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية صحار",
    "province_english": "Sohar Governorate"
  },
  {
    "zone_english": "Al Humbur",
    "zone_arabic": "الهمبار",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية صحار",
    "province_english": "Sohar Governorate"
  },
  {
    "zone_english": "As Suwayhirah",
    "zone_arabic": "الصويحرة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية صحار",
    "province_english": "Sohar Governorate"
  },
  {
    "zone_english": "Al Murabba'ah",
    "zone_arabic": "المربعة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية صحار",
    "province_english": "Sohar Governorate"
  },
  {
    "zone_english": "Al Muwaiji",
    "zone_arabic": "المويجعي",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية صحار",
    "province_english": "Sohar Governorate"
  },
  {
    "zone_english": "Majz Al Kubra",
    "zone_arabic": "مجز الكبرى",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية صحار",
    "province_english": "Sohar Governorate"
  },
  {
    "zone_english": "Al Khabourah",
    "zone_arabic": "الخابورة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية صحم",
    "province_english": "Saham Governorate"
  },
  {
    "zone_english": "Ad Daffah",
    "zone_arabic": "الدفة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية صحم",
    "province_english": "Saham Governorate"
  },
  {
    "zone_english": "Ar Rawdah",
    "zone_arabic": "الروضة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية صحم",
    "province_english": "Saham Governorate"
  },
  {
    "zone_english": "Khor Al Siyabi",
    "zone_arabic": "خور السيابي",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية صحم",
    "province_english": "Saham Governorate"
  },
  {
    "zone_english": "Al Bid'a",
    "zone_arabic": "البدعة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية السويق",
    "province_english": "As Suwaiq Governorate"
  },
  {
    "zone_english": "Al Khadhra",
    "zone_arabic": "الخضراء",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية السويق",
    "province_english": "As Suwaiq Governorate"
  },
  {
    "zone_english": "Al Batash",
    "zone_arabic": "البطاش",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية السويق",
    "province_english": "As Suwaiq Governorate"
  },
  {
    "zone_english": "Hayl Al Hareem",
    "zone_arabic": "حيل الحريم",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية السويق",
    "province_english": "As Suwaiq Governorate"
  },
  {
    "zone_english": "Falaj Al Sham",
    "zone_arabic": "فلج الشام",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية السويق",
    "province_english": "As Suwaiq Governorate"
  },
  {
    "zone_english": "Al Khuwairat",
    "zone_arabic": "الخويرات",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية الخابورة",
    "province_english": "Al Khaboura Governorate"
  },
  {
    "zone_english": "Al Wadi",
    "zone_arabic": "الوادي",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية الخابورة",
    "province_english": "Al Khaboura Governorate"
  },
  {
    "zone_english": "Al Jamahir",
    "zone_arabic": "الجماهير",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية الخابورة",
    "province_english": "Al Khaboura Governorate"
  },
  {
    "zone_english": "Khaboura Industrial",
    "zone_arabic": "صناعة الخابورة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية الخابورة",
    "province_english": "Al Khaboura Governorate"
  },
  {
    "zone_english": "Al Blaidah",
    "zone_arabic": "البليدة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية شناص",
    "province_english": "Shinas Governorate"
  },
  {
    "zone_english": "Ajeeb",
    "zone_arabic": "عجيب",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية شناص",
    "province_english": "Shinas Governorate"
  },
  {
    "zone_english": "Hawza",
    "zone_arabic": "حوزة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية شناص",
    "province_english": "Shinas Governorate"
  },
  {
    "zone_english": "Khor Al Siyabi",
    "zone_arabic": "خور السيابي",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية شناص",
    "province_english": "Shinas Governorate"
  },
  {
    "zone_english": "Hijayramat",
    "zone_arabic": "هجيرمات",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية لوى",
    "province_english": "Liwa Governorate"
  },
  {
    "zone_english": "Harmul",
    "zone_arabic": "حرمول",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية لوى",
    "province_english": "Liwa Governorate"
  },
  {
    "zone_english": "Falaj Bani Kharus",
    "zone_arabic": "فلج بني خزير",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية لوى",
    "province_english": "Liwa Governorate"
  },
  {
    "zone_english": "Ar Rissah",
    "zone_arabic": "الرسة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية لوى",
    "province_english": "Liwa Governorate"
  },
  // محافظة جنوب الباطنة
  {
    "zone_english": "Al Suwadi",
    "zone_arabic": "السوادي",
    "delivery_days": "2",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بركاء",
    "province_english": "Barka Governorate"
  },
  {
    "zone_english": "Al Fulaij",
    "zone_arabic": "الفليج",
    "delivery_days": "2",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بركاء",
    "province_english": "Barka Governorate"
  },
  {
    "zone_english": "Al Abyadh",
    "zone_arabic": "الأبيض",
    "delivery_days": "2",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بركاء",
    "province_english": "Barka Governorate"
  },
  {
    "zone_english": "Al Uqdah",
    "zone_arabic": "العقدة",
    "delivery_days": "2",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بركاء",
    "province_english": "Barka Governorate"
  },
  {
    "zone_english": "Al Hawqayn",
    "zone_arabic": "الحوقين",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية الرستاق",
    "province_english": "Rustaq Governorate"
  },
  {
    "zone_english": "Wadi Bani Ghafir",
    "zone_arabic": "وادي بني غافر",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية الرستاق",
    "province_english": "Rustaq Governorate"
  },
  {
    "zone_english": "Wadi Al Sahtan",
    "zone_arabic": "وادي السحتن",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية الرستاق",
    "province_english": "Rustaq Governorate"
  },
  {
    "zone_english": "Ain Al Kasfa",
    "zone_arabic": "عين الكسفة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية الرستاق",
    "province_english": "Rustaq Governorate"
  },
  {
    "zone_english": "Al Awabi",
    "zone_arabic": "العوابي",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية العوابي",
    "province_english": "Al Awabi Governorate"
  },
  {
    "zone_english": "Sabt",
    "zone_arabic": "سبت",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية العوابي",
    "province_english": "Al Awabi Governorate"
  },
  {
    "zone_english": "Wadi Bani Kharus",
    "zone_arabic": "وادي بني خروص",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية العوابي",
    "province_english": "Al Awabi Governorate"
  },
  {
    "zone_english": "Nakhal",
    "zone_arabic": "نخل",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية نخل",
    "province_english": "Nakhal Governorate"
  },
  {
    "zone_english": "Al Abyadh",
    "zone_arabic": "الأبيض",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية نخل",
    "province_english": "Nakhal Governorate"
  },
  {
    "zone_english": "Wadi Mistal",
    "zone_arabic": "وادي مستل",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية نخل",
    "province_english": "Nakhal Governorate"
  },
  {
    "zone_english": "Al Mahyool",
    "zone_arabic": "المحيول",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية وادي المعاول",
    "province_english": "Wadi Al Maawil Governorate"
  },
  {
    "zone_english": "Al Jabal",
    "zone_arabic": "الجبل",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية وادي المعاول",
    "province_english": "Wadi Al Maawil Governorate"
  },
  {
    "zone_english": "Al Qaryah",
    "zone_arabic": "القرية",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية وادي المعاول",
    "province_english": "Wadi Al Maawil Governorate"
  },
  // محافظة الظاهرة
  {
    "zone_english": "Ibri Center",
    "zone_arabic": "مركز عبري",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية عبري",
    "province_english": "Ibri Governorate"
  },
  {
    "zone_english": "Al Aynayn",
    "zone_arabic": "العينين",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية عبري",
    "province_english": "Ibri Governorate"
  },
  {
    "zone_english": "Al Qabil",
    "zone_arabic": "القابل",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية عبري",
    "province_english": "Ibri Governorate"
  },
  {
    "zone_english": "Yanqul Center",
    "zone_arabic": "مركز ينقل",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية ينقل",
    "province_english": "Yanqul Governorate"
  },
  {
    "zone_english": "Al Shakhar",
    "zone_arabic": "الشقار",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية ينقل",
    "province_english": "Yanqul Governorate"
  },
  {
    "zone_english": "Al Raki",
    "zone_arabic": "الراقي",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية ينقل",
    "province_english": "Yanqul Governorate"
  },
  {
    "zone_english": "As Silayf",
    "zone_arabic": "السليف",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية ضنك",
    "province_english": "Dhank Governorate"
  },
  {
    "zone_english": "Hay Al Ain",
    "zone_arabic": "حي العين",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية ضنك",
    "province_english": "Dhank Governorate"
  },
  {
    "zone_english": "Al Qura",
    "zone_arabic": "القرى",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية ضنك",
    "province_english": "Dhank Governorate"
  },
  {
    "zone_english": "Az Zarw",
    "zone_arabic": "الزرو",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية ضنك",
    "province_english": "Dhank Governorate"
  },
  // محافظة الداخلية
  {
    "zone_english": "Nizwa Center",
    "zone_arabic": "نزوى",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية نزوى",
    "province_english": "Nizwa Governorate"
  },
  {
    "zone_english": "Farq",
    "zone_arabic": "فرق",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية نزوى",
    "province_english": "Nizwa Governorate"
  },
  {
    "zone_english": "Birkat Al Mouz",
    "zone_arabic": "بركة الموز",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية نزوى",
    "province_english": "Nizwa Governorate"
  },
  {
    "zone_english": "Jabreen",
    "zone_arabic": "جبرين",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بهلاء",
    "province_english": "Bahla Governorate"
  },
  {
    "zone_english": "Bisya",
    "zone_arabic": "بسيا",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بهلاء",
    "province_english": "Bahla Governorate"
  },
  {
    "zone_english": "Al Ain",
    "zone_arabic": "العين",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بهلاء",
    "province_english": "Bahla Governorate"
  },
  {
    "zone_english": "Al Ghafat",
    "zone_arabic": "الغافات",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بهلاء",
    "province_english": "Bahla Governorate"
  },
  {
    "zone_english": "Al Qaryah",
    "zone_arabic": "القرية",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية الحمراء",
    "province_english": "Al Hamra Governorate"
  },
  {
    "zone_english": "Al Aridh",
    "zone_arabic": "العارض",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية الحمراء",
    "province_english": "Al Hamra Governorate"
  },
  {
    "zone_english": "Wadi Ghul",
    "zone_arabic": "وادي غول",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية الحمراء",
    "province_english": "Al Hamra Governorate"
  },
  {
    "zone_english": "Al Qaryah",
    "zone_arabic": "القرية",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية أزكي",
    "province_english": "Izki Governorate"
  },
  {
    "zone_english": "Al Nazar",
    "zone_arabic": "النزار",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية أزكي",
    "province_english": "Izki Governorate"
  },
  {
    "zone_english": "Al Nazih",
    "zone_arabic": "النزهه",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية أزكي",
    "province_english": "Izki Governorate"
  },
  {
    "zone_english": "Samail Center",
    "zone_arabic": "سمائل",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية سمائل",
    "province_english": "Samail Governorate"
  },
  {
    "zone_english": "Al Dakhiliyah Industrial",
    "zone_arabic": "المنطقة الصناعية الداخلية",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية سمائل",
    "province_english": "Samail Governorate"
  },
  {
    "zone_english": "Wadi Mahram",
    "zone_arabic": "وادي محرم",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية سمائل",
    "province_english": "Samail Governorate"
  },
  {
    "zone_english": "Manah Center",
    "zone_arabic": "منح",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية منح",
    "province_english": "Manah Governorate"
  },
  {
    "zone_english": "Al Maidan",
    "zone_arabic": "الميدان",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية منح",
    "province_english": "Manah Governorate"
  },
  {
    "zone_english": "Al Fath",
    "zone_arabic": "الفتح",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية منح",
    "province_english": "Manah Governorate"
  },
  {
    "zone_english": "Fanja",
    "zone_arabic": "فنجا",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بدبد",
    "province_english": "Bidbid Governorate"
  },
  {
    "zone_english": "Al Sarhan",
    "zone_arabic": "السرحان",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بدبد",
    "province_english": "Bidbid Governorate"
  },
  {
    "zone_english": "Al Seeh Al Ahmar",
    "zone_arabic": "السيح الأحمر",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بدبد",
    "province_english": "Bidbid Governorate"
  },
  // محافظة  جنوب الشرقية
  {
    "zone_english": "Al Aijah",
    "zone_arabic": "العيجة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية صور",
    "province_english": "Sur Governorate"
  },
  {
    "zone_english": "Tawi",
    "zone_arabic": "طيوي",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية صور",
    "province_english": "Sur Governorate"
  },
  {
    "zone_english": "Ras Al Hadd",
    "zone_arabic": "رأس الحد",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية صور",
    "province_english": "Sur Governorate"
  },
  {
    "zone_english": "Qalhat",
    "zone_arabic": "قلهات",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية صور",
    "province_english": "Sur Governorate"
  },
  {
    "zone_english": "Al Khuwaymah",
    "zone_arabic": "الخوييمة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية جعلان بني بو حسن",
    "province_english": "Jaalan Bani Bu Hassan Governorate"
  },
  {
    "zone_english": "Al Ashkharah",
    "zone_arabic": "الأشخرة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية جعلان بني بو حسن",
    "province_english": "Jaalan Bani Bu Hassan Governorate"
  },
  {
    "zone_english": "Al Najd",
    "zone_arabic": "النجد",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية جعلان بني بو حسن",
    "province_english": "Jaalan Bani Bu Hassan Governorate"
  },
  {
    "zone_english": "Jaalan Bani Bu Ali Center",
    "zone_arabic": "جعلان بني بو علي",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية جعلان بني بو علي",
    "province_english": "Jaalan Bani Bu Ali Governorate"
  },
  {
    "zone_english": "Asilah",
    "zone_arabic": "السيلة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية جعلان بني بو علي",
    "province_english": "Jaalan Bani Bu Ali Governorate"
  },
  {
    "zone_english": "Al Khoud",
    "zone_arabic": "الخوض",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية جعلان بني بو علي",
    "province_english": "Jaalan Bani Bu Ali Governorate"
  },
  // محافظة شمال الشرقية
  {
    "zone_english": "Ibra Center",
    "zone_arabic": "إبراء",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية إبراء",
    "province_english": "Ibra Governorate"
  },
  {
    "zone_english": "Al Yayah",
    "zone_arabic": "اليايح",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية إبراء",
    "province_english": "Ibra Governorate"
  },
  {
    "zone_english": "Al Qabil",
    "zone_arabic": "القابل",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية إبراء",
    "province_english": "Ibra Governorate"
  },
  {
    "zone_english": "Al Mudhaibi Center",
    "zone_arabic": "المضيبي",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية المضيبي",
    "province_english": "Al Mudhaibi Governorate"
  },
  {
    "zone_english": "Sinaw",
    "zone_arabic": "سناو",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية المضيبي",
    "province_english": "Al Mudhaibi Governorate"
  },
  {
    "zone_english": "Al Rawdha",
    "zone_arabic": "الروضة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية المضيبي",
    "province_english": "Al Mudhaibi Governorate"
  },
  {
    "zone_english": "Bidiyah Center",
    "zone_arabic": "بدية",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بدية",
    "province_english": "Bidiyah Governorate"
  },
  {
    "zone_english": "Al Wasil",
    "zone_arabic": "الواصل",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بدية",
    "province_english": "Bidiyah Governorate"
  },
  {
    "zone_english": "Al Raqi",
    "zone_arabic": "الراقي",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بدية",
    "province_english": "Bidiyah Governorate"
  },
  {
    "zone_english": "Al Manjard",
    "zone_arabic": "المنجرد",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية دماء والطائيين",
    "province_english": "Dema and Al Tayeen Governorate"
  },
  {
    "zone_english": "Ad Dami",
    "zone_arabic": "الدامي",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية دماء والطائيين",
    "province_english": "Dema and Al Tayeen Governorate"
  },
  {
    "zone_english": "Al Falaj",
    "zone_arabic": "الفلج",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية دماء والطائيين",
    "province_english": "Dema and Al Tayeen Governorate"
  },
  // محافظة البريمي
  {
    "zone_english": "Buraimi Center",
    "zone_arabic": "البريمي",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية البريمي",
    "province_english": "Al Buraimi Governorate"
  },
  {
    "zone_english": "Al Khandaq",
    "zone_arabic": "الخندق",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية البريمي",
    "province_english": "Al Buraimi Governorate"
  },
  {
    "zone_english": "Al Hila",
    "zone_arabic": "الحلة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية البريمي",
    "province_english": "Al Buraimi Governorate"
  },
  {
    "zone_english": "Mahda Center",
    "zone_arabic": "محضة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية محضة",
    "province_english": "Mahdah Governorate"
  },
  {
    "zone_english": "Al Rawdah",
    "zone_arabic": "الروضة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية محضة",
    "province_english": "Mahdah Governorate"
  },
  {
    "zone_english": "Al Qabil",
    "zone_arabic": "القابل",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية محضة",
    "province_english": "Mahdah Governorate"
  },
  {
    "zone_english": "As Sunaynah Center",
    "zone_arabic": "السنينة",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية السنينة",
    "province_english": "As Sunaynah Governorate"
  },
  {
    "zone_english": "Al Mathfa",
    "zone_arabic": "المضفع",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية السنينة",
    "province_english": "As Sunaynah Governorate"
  },
  {
    "zone_english": "Al Hawi",
    "zone_arabic": "الحوي",
    "delivery_days": "3",
    "delivery_mode": "standard",
    "province_arabic": "ولاية السنينة",
    "province_english": "As Sunaynah Governorate"
  },
  // محافظة ظفار
  {
    "zone_english": "Salalah Center",
    "zone_arabic": "صلالة",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية صلالة",
    "province_english": "Salalah Governorate"
  },
  {
    "zone_english": "Al Saadah",
    "zone_arabic": "السعادة",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية صلالة",
    "province_english": "Salalah Governorate"
  },
  {
    "zone_english": "Al Haffa",
    "zone_arabic": "الحافة",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية صلالة",
    "province_english": "Salalah Governorate"
  },
  {
    "zone_english": "Taqah Center",
    "zone_arabic": "طاقة",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية طاقة",
    "province_english": "Taqah Governorate"
  },
  {
    "zone_english": "Shaat",
    "zone_arabic": "شعت",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية طاقة",
    "province_english": "Taqah Governorate"
  },
  {
    "zone_english": "Ain Arzat",
    "zone_arabic": "عين أرزات",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية طاقة",
    "province_english": "Taqah Governorate"
  },
  {
    "zone_english": "Mirbat Center",
    "zone_arabic": "مرباط",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية مرباط",
    "province_english": "Mirbat Governorate"
  },
  {
    "zone_english": "Sadah Road",
    "zone_arabic": "شارع سدح",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية مرباط",
    "province_english": "Mirbat Governorate"
  },
  {
    "zone_english": "Wadi Ain",
    "zone_arabic": "وادي عين",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية مرباط",
    "province_english": "Mirbat Governorate"
  },
  {
    "zone_english": "Khor Khurfut",
    "zone_arabic": "خور خرفوت",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية سدح",
    "province_english": "Sadah Governorate"
  },
  {
    "zone_english": "Hadeeb",
    "zone_arabic": "حديب",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية سدح",
    "province_english": "Sadah Governorate"
  },
  {
    "zone_english": "Sha'boun",
    "zone_arabic": "شعبون",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية سدح",
    "province_english": "Sadah Governorate"
  },
  {
    "zone_english": "Al Harf",
    "zone_arabic": "الحرف",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية رخيوت",
    "province_english": "Rakhyut Governorate"
  },
  {
    "zone_english": "Al Qaryah",
    "zone_arabic": "القرية",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية رخيوت",
    "province_english": "Rakhyut Governorate"
  },
  {
    "zone_english": "Wadi Anbar",
    "zone_arabic": "وادي عنبر",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية رخيوت",
    "province_english": "Rakhyut Governorate"
  },
  {
    "zone_english": "Dalkut Center",
    "zone_arabic": "ضلكوت",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية ضلكوت",
    "province_english": "Dalkut Governorate"
  },
  {
    "zone_english": "Shaat",
    "zone_arabic": "شعت",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية ضلكوت",
    "province_english": "Dalkut Governorate"
  },
  {
    "zone_english": "Rakhyut Border",
    "zone_arabic": "منفذ رخيوت",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية ضلكوت",
    "province_english": "Dalkut Governorate"
  },
  {
    "zone_english": "Thumrait Center",
    "zone_arabic": "ثمريت",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية ثمريت",
    "province_english": "Thumrait Governorate"
  },
  {
    "zone_english": "Al Khadaf",
    "zone_arabic": "الخذف",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية ثمريت",
    "province_english": "Thumrait Governorate"
  },
  {
    "zone_english": "Wadi Adawnib",
    "zone_arabic": "وادي عتونب",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية ثمريت",
    "province_english": "Thumrait Governorate"
  },
  {
    "zone_english": "Maqshan Center",
    "zone_arabic": "مقشن",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية مقشن",
    "province_english": "Maqshan Governorate"
  },
  {
    "zone_english": "Al Hashman",
    "zone_arabic": "الهشمان",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية مقشن",
    "province_english": "Maqshan Governorate"
  },
  {
    "zone_english": "Al Mazyunah Road",
    "zone_arabic": "طريق المزيونة",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية مقشن",
    "province_english": "Maqshan Governorate"
  },
  {
    "zone_english": "Al Mazyunah Center",
    "zone_arabic": "المزيونة",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية المزيونة",
    "province_english": "Al Mazyunah Governorate"
  },
  {
    "zone_english": "Border Post",
    "zone_arabic": "المنفذ الحدودي",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية المزيونة",
    "province_english": "Al Mazyunah Governorate"
  },
  {
    "zone_english": "Al Qatn",
    "zone_arabic": "القطن",
    "delivery_days": "4",
    "delivery_mode": "standard",
    "province_arabic": "ولاية المزيونة",
    "province_english": "Al Mazyunah Governorate"
  },
  // محافظة الوسطى
  {
    "zone_english": "Hayma Center",
    "zone_arabic": "هيما",
    "delivery_days": "5",
    "delivery_mode": "standard",
    "province_arabic": "ولاية هيما",
    "province_english": "Hayma Governorate"
  },
  {
    "zone_english": "Al Qatbit",
    "zone_arabic": "القطبيت",
    "delivery_days": "5",
    "delivery_mode": "standard",
    "province_arabic": "ولاية هيما",
    "province_english": "Hayma Governorate"
  },
  {
    "zone_english": "Al Ghaftain",
    "zone_arabic": "الغافتين",
    "delivery_days": "5",
    "delivery_mode": "standard",
    "province_arabic": "ولاية هيما",
    "province_english": "Hayma Governorate"
  },
  {
    "zone_english": "Duqm Center",
    "zone_arabic": "الدقم",
    "delivery_days": "5",
    "delivery_mode": "standard",
    "province_arabic": "ولاية الدقم",
    "province_english": "Duqm Governorate"
  },
  {
    "zone_english": "Kahil",
    "zone_arabic": "كهيل",
    "delivery_days": "5",
    "delivery_mode": "standard",
    "province_arabic": "ولاية الدقم",
    "province_english": "Duqm Governorate"
  },
  {
    "zone_english": "Nafun",
    "zone_arabic": "نفون",
    "delivery_days": "5",
    "delivery_mode": "standard",
    "province_arabic": "ولاية الدقم",
    "province_english": "Duqm Governorate"
  },
  {
    "zone_english": "Al Jazir Center",
    "zone_arabic": "الجازر",
    "delivery_days": "5",
    "delivery_mode": "standard",
    "province_arabic": "ولاية الجازر",
    "province_english": "Al Jazir Governorate"
  },
  {
    "zone_english": "Ras Madrakah",
    "zone_arabic": "رأس مدركة",
    "delivery_days": "5",
    "delivery_mode": "standard",
    "province_arabic": "ولاية الجازر",
    "province_english": "Al Jazir Governorate"
  },
  {
    "zone_english": "Sannah",
    "zone_arabic": "سنّه",
    "delivery_days": "5",
    "delivery_mode": "standard",
    "province_arabic": "ولاية الجازر",
    "province_english": "Al Jazir Governorate"
  },
  {
    "zone_english": "Mahout Center",
    "zone_arabic": "محوت",
    "delivery_days": "5",
    "delivery_mode": "standard",
    "province_arabic": "ولاية محوت",
    "province_english": "Mahout Governorate"
  },
  {
    "zone_english": "Suwaihil",
    "zone_arabic": "السويحل",
    "delivery_days": "5",
    "delivery_mode": "standard",
    "province_arabic": "ولاية محوت",
    "province_english": "Mahout Governorate"
  },
  {
    "zone_english": "Filim",
    "zone_arabic": "فلم",
    "delivery_days": "5",
    "delivery_mode": "standard",
    "province_arabic": "ولاية محوت",
    "province_english": "Mahout Governorate"
  },
  // محافظة مسندم
  {
    "zone_english": "Khasab Center",
    "zone_arabic": "خصب",
    "delivery_days": "6",
    "delivery_mode": "standard",
    "province_arabic": "ولاية خصب",
    "province_english": "Khasab Governorate"
  },
  {
    "zone_english": "Tawi Atair",
    "zone_arabic": "طوي أطيط",
    "delivery_days": "6",
    "delivery_mode": "standard",
    "province_arabic": "ولاية خصب",
    "province_english": "Khasab Governorate"
  },
  {
    "zone_english": "Qadah",
    "zone_arabic": "قدح",
    "delivery_days": "6",
    "delivery_mode": "standard",
    "province_arabic": "ولاية خصب",
    "province_english": "Khasab Governorate"
  },
  {
    "zone_english": "Bukha Center",
    "zone_arabic": "بخاء",
    "delivery_days": "6",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بخاء",
    "province_english": "Bukha Governorate"
  },
  {
    "zone_english": "Al Harf",
    "zone_arabic": "الحرف",
    "delivery_days": "6",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بخاء",
    "province_english": "Bukha Governorate"
  },
  {
    "zone_english": "Daba Road",
    "zone_arabic": "طريق دبا",
    "delivery_days": "6",
    "delivery_mode": "standard",
    "province_arabic": "ولاية بخاء",
    "province_english": "Bukha Governorate"
  },
  {
    "zone_english": "Daba Center",
    "zone_arabic": "دبا",
    "delivery_days": "6",
    "delivery_mode": "standard",
    "province_arabic": "ولاية دبا",
    "province_english": "Daba Governorate"
  },
  {
    "zone_english": "Sabt",
    "zone_arabic": "سبت",
    "delivery_days": "6",
    "delivery_mode": "standard",
    "province_arabic": "ولاية دبا",
    "province_english": "Daba Governorate"
  },
  {
    "zone_english": "Al Wadi",
    "zone_arabic": "الوادي",
    "delivery_days": "6",
    "delivery_mode": "standard",
    "province_arabic": "ولاية دبا",
    "province_english": "Daba Governorate"
  },
  {
    "zone_english": "Madha Center",
    "zone_arabic": "مدحاء",
    "delivery_days": "6",
    "delivery_mode": "standard",
    "province_arabic": "ولاية مدحاء",
    "province_english": "Madha Governorate"
  },
  {
    "zone_english": "Al Muraija",
    "zone_arabic": "المريجة",
    "delivery_days": "6",
    "delivery_mode": "standard",
    "province_arabic": "ولاية مدحاء",
    "province_english": "Madha Governorate"
  },
  {
    "zone_english": "Al Qurun",
    "zone_arabic": "القرون",
    "delivery_days": "6",
    "delivery_mode": "standard",
    "province_arabic": "ولاية مدحاء",
    "province_english": "Madha Governorate"
  }
    ];

    function formatDate(date) {
      const days = isArabic ? daysAr : daysEn;
      const months = isArabic ? monthsAr : monthsEn;
      return `${days[date.getDay()]}, ${date.getDate()} ${months[date.getMonth()]}`;
    }

    function updateOmanEstimate(area) {
      if (!area || !area.delivery_days || isNaN(area.delivery_days)) return;
      const days = parseInt(area.delivery_days);
      const now = new Date();
      const from = new Date(now);
      const to = new Date(now);
      from.setDate(now.getDate() + (days <= 2 ? 1 : 2));
      to.setDate(now.getDate() + days);

     flagSpan.innerHTML = '<img src="https://cdn.shopify.com/static/images/flags/om.svg" style="width: 20px; height: 14px; vertical-align: middle;">';

      estimateText.innerHTML = isArabic
        ? `أطلب الآن ليصلك بين <strong>${formatDate(from)}</strong> و <strong>${formatDate(to)}</strong>`
        : `Order now to receive between <strong>${formatDate(from)}</strong> and <strong>${formatDate(to)}</strong>`;

      estimateBox.classList.add('visible');
    }

    function updateGulfEstimate(country) {
      const now = new Date();
      const from = new Date(now);
      const to = new Date(now);
      from.setDate(now.getDate() + gulfCountries[country].from);
      to.setDate(now.getDate() + gulfCountries[country].to);

      const code = flagCodes[country] || 'om';
      flagSpan.innerHTML = `<img src="https://cdn.shopify.com/static/images/flags/${code}.svg" style="width: 20px; height: 14px; vertical-align: middle;">`;

      estimateText.innerHTML = isArabic
        ? `أطلب الآن ليصلك بين <strong>${formatDate(from)}</strong> و <strong>${formatDate(to)}</strong>`
        : `Order now to receive between <strong>${formatDate(from)}</strong> and <strong>${formatDate(to)}</strong>`;

      estimateBox.classList.add('visible');
    }

    function createMultiLevelSelect() {
      inputContainer.innerHTML = `
        <div class="multi-level-selector">
          <div class="select-wrapper">
            <input type="text" id="provinceInput" placeholder="${isArabic ? 'اختر الولاية' : 'Select Wilaya'}" class="select-input">
            <ul id="provinceDropdown" class="dropdown-list"></ul>
          </div>
          <div class="select-wrapper" id="zoneWrapper" style="display: none; margin-top: 8px;">
            <input type="text" id="zoneInput" placeholder="${isArabic ? 'اختر المنطقة' : 'Select Area'}" class="select-input">
            <ul id="zoneDropdown" class="dropdown-list"></ul>
          </div>
        </div>
      `;

      const provinceInput = document.getElementById('provinceInput');
      const provinceDropdown = document.getElementById('provinceDropdown');
      const zoneWrapper = document.getElementById('zoneWrapper');
      const zoneInput = document.getElementById('zoneInput');
      const zoneDropdown = document.getElementById('zoneDropdown');

      const provincesMap = new Map();
      omanAreas.forEach(area => {
        const provinceName = isArabic ? area.province_arabic : area.province_english;
        if (!provincesMap.has(provinceName)) {
          provincesMap.set(provinceName, []);
        }
        provincesMap.get(provinceName).push(area);
      });

      const sortedProvinces = Array.from(provincesMap.keys()).sort((a, b) =>
        a.localeCompare(b, isArabic ? 'ar' : 'en')
      );

      let selectedProvince = "";

      function renderProvinceList(filter = "") {
        provinceDropdown.innerHTML = '';
        sortedProvinces
          .filter(province => province.includes(filter))
          .forEach(province => {
            const li = document.createElement('li');
            li.textContent = province;
            li.addEventListener('click', () => {
              provinceInput.value = province;
              provinceDropdown.style.display = 'none';
              selectedProvince = province;
              zoneWrapper.style.display = 'block';
              zoneInput.value = '';
              renderZoneList("");
            });
            provinceDropdown.appendChild(li);
          });
      }

      function renderZoneList(filter = "") {
        zoneDropdown.innerHTML = '';
        const zones = provincesMap.get(selectedProvince) || [];
        zones
          .filter(area => {
            const name = isArabic ? area.zone_arabic : area.zone_english;
            return name.includes(filter);
          })
          .forEach(area => {
            const li = document.createElement('li');
            li.textContent = isArabic ? area.zone_arabic : area.zone_english;
            li.addEventListener('click', () => {
              zoneInput.value = isArabic ? area.zone_arabic : area.zone_english;
              zoneDropdown.style.display = 'none';
              updateOmanEstimate(area);
              localStorage.setItem("selected_delivery_area", JSON.stringify(area));
            });
            zoneDropdown.appendChild(li);
          });
      }

      provinceInput.addEventListener('focus', () => {
        renderProvinceList();
        provinceDropdown.style.display = 'block';
      });

      zoneInput.addEventListener('focus', () => {
        renderZoneList();
        zoneDropdown.style.display = 'block';
      });

      provinceInput.addEventListener('input', (e) => {
        renderProvinceList(e.target.value.trim());
      });

      zoneInput.addEventListener('input', (e) => {
        renderZoneList(e.target.value.trim());
      });

      document.addEventListener('click', (e) => {
        if (!e.target.closest('.select-wrapper')) {
          provinceDropdown.style.display = 'none';
          zoneDropdown.style.display = 'none';
        }
      });

      const savedArea = localStorage.getItem("selected_delivery_area");
      if (savedArea) {
        try {
          const area = JSON.parse(savedArea);
          const provinceName = isArabic ? area.province_arabic : area.province_english;
          const zoneName = isArabic ? area.zone_arabic : area.zone_english;
          provinceInput.value = provinceName;
          zoneInput.value = zoneName;
          selectedProvince = provinceName;
          zoneWrapper.style.display = 'block';
          updateOmanEstimate(area);
        } catch (e) {}
      }
    }

    function createCountrySelect() {
      inputContainer.innerHTML = `
        <select id="locationSelect" class="select-input"></select>
      `;

      const select = document.getElementById('locationSelect');
      Object.keys(gulfCountries).forEach(country => {
        const option = document.createElement('option');
        option.value = country;
        option.textContent = country;
        select.appendChild(option);
      });

      select.addEventListener('change', () => {
        updateGulfEstimate(select.value);
      });

      updateGulfEstimate(select.value);
    }

    function refreshDelivery(currencyCode) {
      const isOman = currencyCode === 'OMR';
      if (isOman) {
        createMultiLevelSelect();
      } else {
        createCountrySelect();
      }
    }

    document.querySelectorAll('.t4s-currency-item').forEach(btn => {
      btn.addEventListener('click', () => {
        setTimeout(() => {
          const currency = btn.getAttribute('data-currency')?.toUpperCase() || 'OMR';
          refreshDelivery(currency);
        }, 300);
      });
    });

    const currency = (Shopify && Shopify.currency && Shopify.currency.active)
      ? Shopify.currency.active
      : "{{ shop.currency }}";

    refreshDelivery(currency.toUpperCase());

  } catch (e) {
    console.error("Delivery Estimator Error:", e);
  }
});
